import { isMobileQuery } from "../utils/utils"

import Swiper, { Scrollbar, A11y, Autoplay } from "swiper"
Swiper.use(Scrollbar, A11y, Autoplay)
// import Swiper styles
import "swiper/swiper-bundle.css"

class MobileCarousel {
  constructor() {
    this.selector = ".mobile-carousel"
    this.containerSelector = ".swiper-container.swiper-container--mobile"
    this.instances = []

    // Wait for 1 second so that the page elements to load
    // Without the wait, random behaviour happens to swiper (ie. duplicated slides, no space between, slide not accurate)
    setTimeout(() => {
      this.initCarousel(isMobileQuery)
      isMobileQuery.addEventListener("change", this.initCarousel.bind(this))
    }, 1000)
  }

  initCarousel(mediaQuery) {
    if (document.querySelector(this.selector)) {
      if (mediaQuery.matches) {
        this.createCarousel()
      } else {
        if (this.instances.length) {
          this.instances.forEach(swiper => {
            swiper.destroy(true, true)
          })
          this.toggleComponentClasses()
        }
      }
    }
  }

  createCarousel() {
    this.instances = []
    this.toggleComponentClasses()

    const defaultOptions = {
      // Optional parameters
      direction: "horizontal",
      loop: false,
      slidesPerView: 1,
      spaceBetween: 25,
      autoplay: {
        delay: 5000,
      },
      keyboard: {
        enabled: true,
      },
      disableOnInteraction: true,

      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    }

    document.querySelectorAll(this.selector).forEach(el => {
      const options = { ...defaultOptions }
      if (el.dataset.mobileCarouselSlider) {
        options.scrollbar = {
          el: ".swiper-scrollbar",
          snapOnRelease: true,
        }
      }

      // global Swiper
      this.instances.push(new Swiper(el, options))
    })
  }

  /**
   * Toggle classes of carousel components to allow use the same markup on desktop
   */
  toggleComponentClasses() {
    const selector = this.selector
    this.selector = this.containerSelector
    this.containerSelector = selector

    document.querySelectorAll("[data-mobile-carousel]").forEach(e => {
      const classList = e.classList.toString()
      e.classList = e.dataset.mobileCarousel
      e.dataset.mobileCarousel = classList
    })
  }
}

export default MobileCarousel
